
import {AppLink as Link, AppWrapper} from "../components/helpers";

export default function Pages(props) {
   return <AppWrapper>
     <div className="container-fluid p-2">
   
         <div className="row p-2">
             <div className="col-4 p-2">
             <div className="card">
  
  <div className="card-body">
    <h5 className="card-title">Master Blocks</h5>
    <Link  href="/master-blocks" className="btn btn-primary me-2">View</Link>
    <Link  href="/master-blocks/add" className="btn btn-primary me-2">Add Item</Link>
  </div>
</div>
          </div>
          <div className="col-4 p-2">
             <div className="card">
  
  <div className="card-body">
    <h5 className="card-title">Blocks</h5>
    <Link  href="/blocks" className="btn btn-primary me-2">View</Link>
    {/* <Link  href="/blocks/add" className="btn btn-primary me-2">Add Item</Link> */}
  </div>
</div>
          </div>
          <div className="col-4 p-2">
             <div className="card">
  
  <div className="card-body">
    <h5 className="card-title">Templates</h5>
    <Link  href="/pages" className="btn btn-primary me-2">View</Link>
    {/* <Link  href="/pages/add" className="btn btn-primary me-2">Add Item</Link> */}
  </div>
</div>
          </div>
             </div>
         </div>
     
    </AppWrapper>
}